import { Company } from '../companies/company.model';
import { Note } from '../../shared/notes/note.model';
import { Contact } from '../contacts/contact.model';
import { Task } from '../../shared/tasks/task.model';
import { Project } from '../projects/project.model';
import { Attachment } from '../../shared/attachments/attachment.model';
// import { ProjectProgress } from './components/project-steps/project-step.model';


export class EventBB {

  _id?: string;
  reference: number;

  /* basic company info */
  name: string;
  status: string = '';
  eventType: string = '';
  description: string = '';
  eventPartner: Company;

  budgetedCost: number = 0;
  actualCost: number = 0;

  // myMoment: moment.Moment
  // date: Date = new Date();
  eventDate: Date = new Date();

  // Main Address
  line1?: string = '';
  line2?: string = '';
  city?: string = '';
  postcode?: string = '';
  county?: string = '';
  country?: string = '';

  /* for logging the status of the project */
  currentStatus: string;
  currentStatusId: number = 0;

  /* list of steps/buyers */
  attendees: EventAttendee[] = [];
  tasks: Task[] = [];
  attachments: Attachment[] = [];
  notes: Note[] = [];

  constructor() { }

}


export enum EventStatus {
  Active = 1,
  Paused,
  Completed,
  Withdrawn,
  Closed
}

export enum EventType {
  Meeting = 1,
  Breakfast,
  Seminar,
  Lecture,
  Conference,
  Advisory,
  Discussion
}


export class EventAttendee {

  /* basic step info */
  attendee: Contact;
  status?: string;
  hasResponded: boolean = false;
  firstRespondedDate?: Date;
  project?: Project;

  constructor(attendee: Contact) {
    this.attendee = attendee;
    this.status = '';
  }

}

export enum AttendeeStatus {
  SeminarBooked = 1,
  MapAndDirectionsSent,
  ConfirmedAttending,
  Declined,
  Invited,
  TickedForAMeeting,
  NoShow,
  Attended,
}



// WEBPACK FOOTER //
// ./client/app/features/events/event.model.ts